import { createElement } from "react";

import ClientTranslation from "components/ClientTranslation";
import Flex from "components/Flex";
import Text from "components/Text";
import { SizeVariant } from "components/Text/types";

import { useStyles } from "./styles";
import { tips } from "./variants";

type TipProps = {
  variant: keyof typeof tips;
  sizeVariant: SizeVariant;
};

export const Tip = ({ variant, sizeVariant = "base" }: TipProps) => {
  const { icon, text, translationKey } = tips[variant];

  const { classes } = useStyles();

  return (
    <Flex as="li" direction="row" align="flex-start" gap={10}>
      <div className={classes.icon}>{createElement(icon)}</div>

      <Text sizeVariant={sizeVariant}>{<ClientTranslation i18nKey={translationKey}>{text}</ClientTranslation>}</Text>
    </Flex>
  );
};
